// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"assets-vehicle-information_modalTitle_JaX5s","okBtn":"assets-vehicle-information_okBtn_2FByC"};